import React from 'react';
import {Modal} from 'antd';
const Publish = ({service, children}) => (
    <a href="javascript:;" onClick={() => {
        if(service.getSelection().length === 0) {
            Modal.confirm({
                title: '确定发布所有记录？',
                content: '未选中记录时，默认发布所有记录！',
                onOk() {
                    window.location.hash = service.publishURL;
                },
                onCancel() {},
                okText:"确认",
                cancelText:"取消"
            });
        } else {
            window.location.hash = service.publishURL;
        }
        
    }}><i className="fa fa-external-link" aria-hidden="true"></i>{children || "发布"}</a>
);

export default Publish;